import React, { useState } from 'react'
import _ from 'lodash'
import { RouteComponentProps } from '@reach/router'
// Components
import AssetDetails from 'components/asset-management/reports/asset-details'
import ChartDetails from 'components/asset-management/reports/chart-details'
import PortfolioDetail from 'components/asset-management/reports/portfolio-detail'
// Data
import propertyReportService from 'data/reports-property'
// Styles
import { Button_s, H4 } from 'styles/app-styles'
import { ReportContainer_s, ReportForms_s, ReportSelection_s, ReportSelectionItem_s } from 'styles/report-styles'

interface AMReport {
  name: string
  value: string
  runBtnOnly?: boolean
}

const reports = [
  { name: 'Asset Details', value: 'asset_details' },
  { name: 'Attributes', value: 'attribute', runBtnOnly: true },
  { name: 'Chart Details', value: 'chart_details' },
  { name: 'Portfolio Details', value: 'portfolio_detail', component: PortfolioDetail },
  { name: 'Users', value: 'users', runBtnOnly: true  },
  { name: 'User Groups', value: 'user_group', runBtnOnly: true  }
]

const AMReports = (props: RouteComponentProps) => {
  const [activeReport, setReport] = useState<AMReport>(reports[0]);

  return (
    <ReportContainer_s>
      <ReportSelection_s>
        <H4>Reports</H4>
        <ul>
          { reports.map((report) => (
            <ReportSelectionItem_s active={activeReport.name === report.name} onClick={()=>{setReport(report)}}>
              {report.name}
            </ReportSelectionItem_s>
          ))}
        </ul>
      </ReportSelection_s>
      <ReportForms_s className="slim-scroll slim-scroll-hover">
        { activeReport.runBtnOnly &&
          <Button_s primary onClick={() => propertyReportService.propertyReport({report: activeReport.value})}>Run Report</Button_s>
        }
        { activeReport.name === 'Asset Details' && <AssetDetails /> }
        { activeReport.name === 'Chart Details' && <ChartDetails /> }
        { activeReport.name === 'Portfolio Details' && <PortfolioDetail /> }
      </ReportForms_s>
    </ReportContainer_s>
  )
}

export default AMReports
